export default __webpack_public_path__ + "static/media/You're_all_set.1a1f2986.svg";